import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { MapAutonomousCommunity, MapMunicipality, MapMunicipalityWitGeojson, MapProvince } from '../../../services/map-municipalities.service'
import { MapAutonomousCommunitySelect } from './MapAutonomousCommunitySelect'
import { MapProvinceSelect } from './MapProvinceSelect'
import { MapMunicipalitySelect } from './MapMunicipalitySelect'

export const ADD_ALL_ID = 0;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
`;

const Col3 = styled.div`
  flex: 0 0 25%;
  max-width: 25%;
  padding: 0 15px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
    padding-bottom: 10px;
  }
`;

const Col6 = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  padding: 0 15px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex: 0 0 100%;
    max-width: 100%;
    padding-bottom: 10px;
  }
`;



type Props = {
  handleSelectWholeSpain: () => void
  handleAutonomousCommunitySelection: (autonomousCommunity: MapAutonomousCommunity) => void
  handleProvinceSelection: (province: MapProvince) => void
  handleMunicipalitySelection: (municipality: MapMunicipalityWitGeojson) => void,

  selectedAutonomousCommunities: MapAutonomousCommunity[],
  selectedProvinces: MapProvince[],
  selectedMunicipalities: MapMunicipality[]
}

export const MapMunicipalitySearchForm: React.FC<Props> = ({
  handleSelectWholeSpain,
  handleAutonomousCommunitySelection,
  handleProvinceSelection,
  handleMunicipalitySelection,
  selectedAutonomousCommunities,
  selectedProvinces,
  selectedMunicipalities }) => {

  const [selectedAutonomousCommunity, selectAutonomousCommunity] = useState<MapAutonomousCommunity>()
  const [selectedProvince, selectProvince] = useState<MapProvince>()

  const handleSelectAutonomousCommunity = async (autonomousCommunity: MapAutonomousCommunity) => {
    if (autonomousCommunity.id === selectedAutonomousCommunity?.id) {
      return;
    }
    selectAutonomousCommunity(autonomousCommunity)
    selectProvince(undefined)
  }

  const handleSelectProvince = async (province: MapProvince) => {
    if (province.id === selectedProvince?.id) {
      return;
    }
    selectProvince(province)
  }
    
  const isWholeSpainSelected = selectedAutonomousCommunities.some(it => it.id === ADD_ALL_ID);

    return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <label>Selección geoespacial</label>
        </div>
      </div>
      <Row>
        <Col3>
          <MapAutonomousCommunitySelect
            disabled={false || isWholeSpainSelected}
            handleSelectWholeSpain={handleSelectWholeSpain}
            handleSelection={handleSelectAutonomousCommunity}
            selectedAutonomousCommunities={selectedAutonomousCommunities}
          />
        </Col3>
        <Col3>
          <MapProvinceSelect
            disabled={false || isWholeSpainSelected}
            selectedAutonomousCommunities={selectedAutonomousCommunities}
            lastSelectedAutonomousCommunity={selectedAutonomousCommunity}
            selectedProvinces={selectedProvinces}
            lastSelectedProvince={selectedProvince}
            handleSelection={handleSelectProvince}
            handleAutonomousCommunitySelection={handleAutonomousCommunitySelection} />
        </Col3>
        <Col6>
          <MapMunicipalitySelect
            disabled={false || isWholeSpainSelected}
            lastSelectedProvince={selectedProvince}
            selectedProvinces={selectedProvinces}
            selectedMunicipalities={selectedMunicipalities}
            handleSelection={handleMunicipalitySelection}
            handleProvinceSelection={handleProvinceSelection}
          />
        </Col6>
      </Row>
    </div>
  )
}
